export const REACTIONS_PRELOAD_SSR_FF = 'confluence.ssr.reactions.preload';

const THUMBS_UP = '1f44d';
const CLAP = '1f44f';
const TADA = '1f389';
export const defaultEmojis = [THUMBS_UP, CLAP, TADA];
